/**
 * Manage global libraries like jQuery or THREE from the package.json file
 */
// Import custom modules
import App from'./modules/app';
import './modules/funds-cookie-bar';
import Search from './modules/funds-search'; // ./modules/funds imported here
import Dropdowns from './modules/dropdowns';
import './modules/funds-homepage-form'; 
//import Funds from './modules/funds'; 
import Modals from './modules/modals';
import SVG_Map from './modules/svg-map';
import Menu from './modules/menu'
import Share from './modules/share'

new Dropdowns();
new Modals();
new SVG_Map();
//new Funds();
new Search();
new Menu('main-nav', 'hamburger');
new Share('.share-dialog');

const app = new App();

// add target = "_blank" to every external link
var baseUrl = window.location.host;
$("body").on('click', "a[href^='http:']:not([href*='" + baseUrl + "']), " + "a[href^='https:']:not([href*='" + baseUrl + "']), " + "a[href$='.pdf']:not([href*='" + baseUrl + "']), " + "a[href$='.pdf'], " + "a.external", function () {
    return $(this).attr('target', '_blank');
});



// WEBPACK FOOTER //
// ./scripts/main.js